/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from "react";
import { getMenuParentElements, menuHasChildren } from "../../menuHelpers";

const MobileMainMenu = (props) => {
  const { sitemegamenu, activeMenu, setActiveMenu, sitemegamenumuotolevy } = props;
  const [open, setOpen] = useState(false);
  const parentMenu = getMenuParentElements(
    sitemegamenu.concat(sitemegamenumuotolevy), // NOTE: concat megamenu and muotolevy-menu
  );
  
  if (!parentMenu) return null;
  
  return (
    <React.Fragment>
      <button
        className={`hamburger hamburger--squeeze ${open && "is-active"}`}
        type="button"
        onClick={() => {
          setOpen(!open);
          setActiveMenu(null);
        }}
      >
        <span className="hamburger-box">
          <span className="hamburger-inner" />
        </span>
      </button>
      {open && (
        <ul className="megamenu__main megamenu__mobile-main menu">
          {parentMenu.map((item) => {
            const hasChildren = menuHasChildren(
              sitemegamenu.concat(sitemegamenumuotolevy),
              item.ID,
            );
            
            if (!hasChildren) {
              return (
                <li key={item.ID}>
                  <a href={item.url}>{item.title}</a>
                </li>
              );
            }
            
            return (
              <li key={item.ID}>
                <a
                  role="button"
                  onClick={(e) => {
                    e.preventDefault();
                    if (activeMenu && activeMenu.ID === item.ID) {
                      setActiveMenu(null);
                    } else {
                      setActiveMenu(item);
                    }
                  }}
                >
                  {item.title}
                </a>
              </li>
            );
          })}
        </ul>
      )}
    </React.Fragment>
  );
};

export default MobileMainMenu;